import { useEffect } from 'react'
import { videoTag } from '../constants'
import { handleVideoTimeline } from '../../redux/actions/controller.actions'
import store from '../../redux/store'
import { useAppSelector } from 'redux-share'
import { shallowEqual } from "react-redux";
import { sendFluentLog, watchedTimeLog } from 'logs'
import { handleContinuousPlayback } from 'ui/src/playerComponents/continuousPlayback/continuousePlayback'

const useBeforeUnload = () => {

  useAppSelector(({ user: { isLogin } }) => ({ isLogin }), shallowEqual);

  useEffect(() => {
    const handleBeforeUnload = () => {
      const { watchedTime } = store.getState().videoData
      sendFluentLog(watchedTimeLog(watchedTime))
      handleVideoTimeline(videoTag().currentTime)
      handleContinuousPlayback();
    }

    window.addEventListener('beforeunload', handleBeforeUnload)
    return () => window.removeEventListener('beforeunload', handleBeforeUnload)
  }, [])
}

export default useBeforeUnload